module.exports = __webpack_public_path__ + "img/small_mounted_prints.93f940fc.jpg";